import type { FaireProductEntity } from "../../entity_types/product";

export const p_6yfn8y25ax: FaireProductEntity = {
  token: "p_6yfn8y25ax",
  type: "product",
  name: "4 pc Ocean jasper Carnelian Moss agate moon H423",
  brandToken: "b_yrt8x5m6m6",
  brandName: "The 7 Directions",
  imageUrl:
    "https://cdn.faire.com/fastly/3a6383eade9dd7c72b1fb9c7a323413048a5d2914c7058003c8f7e61daa9413e.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/df57e5ff203cfb95ed3cdeaa8e071860f3b2e13b328b00f807abf52d8fc42651.jpeg",
    "https://cdn.faire.com/fastly/56878cbca8dadd29977d40fe26367ae5a1f0865e298509bdd0beb575dc6fa593.jpeg",
    "https://cdn.faire.com/fastly/04c36e91c32f5121e38ba022151cc0ea0815e138fe16d70937a744cf0f4000e5.jpeg",
    "https://cdn.faire.com/fastly/779e3347589f89ebbf8f0fd7ef1c2667374ec1c50fb541b5ad3389d4c524f857.jpeg",
    "https://cdn.faire.com/fastly/66bdbe6cb9e72535fb99f0a080c8a3bf65e26dedd90641629f97a958481dd9b1.jpeg",
  ],
  priceDollars: 73.44,
  description:
    '4 pc Ocean jasper Carnelian Moss agate moon H423\n\nComes with 3 crystal information card\n\nThis is the exact set you will receive\n\nApprox 4" - 4 1/2"\n\nThese items are made from genuine natural stones. Due to their organic origin, you may encounter minor inclusions, fissures (cracks), surface divots, and slight color variations from piece to piece. ',
  tags: [],
  msrpDollars: 146.88,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:24:44.496Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
